import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const traspasoEntreAlmacenesPdf = (values) => {
  const empresa = values.empresa;
  const insumos = values.insumos;
  const orden = values.orden;
  const logoBiwo = values.logoBiwo;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;

  const folioTexto = `${orden.serie ? orden.serie + " - " : ""}${orden.numero || ""}` || "-";

  const layoutTabla = {
    hLineWidth: () => 1,
    vLineWidth: () => 1,
    hLineColor: () => "#e8e8e8",
    vLineColor: () => "#e8e8e8",
    fillColor: (rowIndex) => (rowIndex === 0 ? null : rowIndex % 2 === 0 ? "#f9f9f9" : null),
  };

  const estiloHeaderTabla = {
    bold: true,
    fontSize: 9,
    color: "black",
    fillColor: "#dedede",
    margin: [4, 4, 4, 4],
  };

  const estiloCelda = {
    fontSize: 9,
    margin: [4, 4, 4, 4],
  };

  const conceptos = insumos.map((valueConcepto) => {
    return [
      { text: valueConcepto.clave, style: estiloCelda, alignment: "center" },
      {
        text:
          valueConcepto.descripcion +
          (valueConcepto.observaciones ? "\n" + valueConcepto.observaciones : ""),
        style: estiloCelda,
        alignment: "left",
      },
      { text: valueConcepto.unidad, style: estiloCelda, alignment: "center" },
      { text: valueConcepto.cantidad, style: estiloCelda, alignment: "right" },
    ];
  });

  const filasCabecera = [
    [
      { text: "Almacén Salida", style: estiloHeaderTabla },
      {
        text: orden.proyectoOrigen.nombre + " - " + orden.proyectoOrigen.descripcion,
        style: estiloCelda,
      },
      { text: "Almacén Entrada", style: estiloHeaderTabla },
      {
        text: orden.proyectoDestino.nombre + " - " + orden.proyectoDestino.descripcion,
        style: estiloCelda,
      },
    ],
    [
      { text: "Fecha Registro", style: estiloHeaderTabla },
      {
        text: moment(orden.createdAt).locale("es").format("LL"),
        style: estiloCelda,
      },
      { text: "Fecha Traspaso", style: estiloHeaderTabla },
      {
        text: moment(orden.fechaTraspaso || orden.createdAt).locale("es").format("LL"),
        style: estiloCelda,
      },
    ],
    [
      { text: "Responsable", style: estiloHeaderTabla },
      {
        text:
          orden.usuario.nombre +
          " " +
          orden.usuario.apellidoPaterno +
          " " +
          orden.usuario.apellidoMaterno,
        style: estiloCelda,
        colSpan: 3,
      },
      {},
      {},
    ],
  ];

  if (orden.observaciones) {
    filasCabecera.push([
      { text: "Observaciones", style: estiloHeaderTabla },
      { text: orden.observaciones, style: estiloCelda, colSpan: 3 },
      {},
      {},
    ]);
  }

  const folioMovimiento = (mov) => {
    if (!mov) return "-";
    if (mov.serieTipo || mov.folioTipo) {
      return `${mov.serieTipo ? mov.serieTipo + " - " : ""}${mov.folioTipo || ""}`;
    }
    return "-";
  };

  if (orden.movimientoSalida || orden.movimientoEntrada) {
    filasCabecera.push([
      { text: "Mov. Salida", style: estiloHeaderTabla },
      { text: folioMovimiento(orden.movimientoSalida), style: estiloCelda },
      { text: "Mov. Entrada", style: estiloHeaderTabla },
      { text: folioMovimiento(orden.movimientoEntrada), style: estiloCelda },
    ]);
  }

  if (orden.estado === 0 && orden.cancelacion) {
    const c = orden.cancelacion;
    const usrC = c.usuarioCancelacion
      ? `${c.usuarioCancelacion.nombre || ""} ${c.usuarioCancelacion.apellidoPaterno || ""} ${c.usuarioCancelacion.apellidoMaterno || ""}`.trim()
      : null;
    filasCabecera.push([
      { text: "Cancelado por", style: estiloHeaderTabla },
      { text: usrC || "-", style: estiloCelda },
      { text: "Fecha Cancelación", style: estiloHeaderTabla },
      {
        text: c.fechaCancelacion
          ? moment(c.fechaCancelacion).locale("es").format("LL")
          : "-",
        style: estiloCelda,
      },
    ]);
    if (c.motivo) {
      filasCabecera.push([
        { text: "Motivo Cancelación", style: estiloHeaderTabla },
        { text: c.motivo, style: estiloCelda, colSpan: 3 },
        {},
        {},
      ]);
    }
  }

  let cancelado = {};
  if (orden.estado === 0) {
    cancelado = {
      watermark: {
        text: "CANCELADO",
        color: "gray",
        opacity: 0.2,
        bold: true,
        italics: false,
        angle: 45,
      },
    };
  }

  const dd = {
    ...cancelado,
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 50,
    },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["20%", "50%", "30%"],
          layout: "noBorders",
          body: [
            [
              ...HeaderEmpresaCard(empresa, mostrarRegimen, false, {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Folio:", style: "subheader", alignment: "center" }],
                    [{ text: folioTexto, style: "textoChico", alignment: "center" }],
                    [{ text: "Fecha Registro:", style: "subheader", alignment: "center" }],
                    [
                      {
                        text: moment(orden.createdAt).locale("es").format("LL"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [{ text: "Fecha Traspaso:", style: "subheader", alignment: "center" }],
                    [
                      {
                        text: moment(orden.fechaTraspaso || orden.createdAt)
                          .locale("es")
                          .format("LL"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },

      {
        text: `Traspaso Entre Almacenes  ${folioTexto}`,
        style: "tituloPrincipal",
        alignment: "left",
        margin: [0, 5, 0, 10],
      },

      {
        style: "tableExample",
        margin: [0, 0, 0, 12],
        table: {
          widths: ["18%", "32%", "18%", "32%"],
          body: filasCabecera,
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#bdbdbd",
          vLineColor: () => "#bdbdbd",
        },
      },

      { text: "Detalle de Insumos", style: "tableHeaderIzquierda", margin: [0, 0, 0, 5] },
      {
        table: {
          widths: ["20%", "60%", "10%", "10%"],
          body: [
            [
              { text: "Clave", style: estiloHeaderTabla, alignment: "center" },
              { text: "Descripción", style: estiloHeaderTabla, alignment: "center" },
              { text: "Unidad", style: estiloHeaderTabla, alignment: "center" },
              { text: "Cantidad", style: estiloHeaderTabla, alignment: "center" },
            ],
            ...conceptos,
          ],
        },
        layout: layoutTabla,
        margin: [0, 0, 0, 10],
      },

      {
        style: "tableExample",
        margin: [0, 50, 0, 0],
        table: {
          widths: ["35%", "30%", "35%"],
          body: [
            [
              {
                text: "Entrega",
                style: estiloCelda,
                alignment: "center",
                border: [false, true, false, false],
              },
              { text: "", style: estiloCelda, alignment: "center", border: [false, false, false, false] },
              {
                text: "Recibe",
                style: estiloCelda,
                alignment: "center",
                border: [false, true, false, false],
              },
            ],
          ],
        },
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      tituloPrincipal: { fontSize: 16, bold: true, color: "black" },
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 0, 0, 0] },
      tableHeaderIzquierda: { bold: true, fontSize: 13, color: "black" },
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico: { fontSize: 8 },
    },
    pageSize: "LETTER",
    pageMargins: [40, 40, 40, 40],
  };
  return dd;
};

export default traspasoEntreAlmacenesPdf;
